var map = {
	"./left-bottom-row-1.webp": "a4db",
	"./left-bottom-row-2.webp": "f1e9",
	"./left-bottom-row-3.webp": "e04d",
	"./left-bottom-row-4.webp": "41fe",
	"./left-bottom-row-5.webp": "fcbb",
	"./left-bottom-row-6.webp": "2a68",
	"./left-bottom-row-7.webp": "4f61",
	"./left-home-row-1.webp": "4a2a",
	"./left-home-row-2.webp": "1f12",
	"./left-home-row-3.webp": "286d",
	"./left-home-row-4.webp": "e762",
	"./left-home-row-5.webp": "d3a1",
	"./left-num-row-2.webp": "7b51",
	"./left-num-row-3.webp": "b30f",
	"./left-num-row-4.webp": "2743",
	"./left-num-row-5.webp": "16c3",
	"./left-num-row-6.webp": "958d",
	"./left-num-row-7.webp": "97e6",
	"./left-resting-hand.webp": "b121",
	"./left-top-row-1.webp": "1fa0",
	"./left-top-row-2.webp": "07fd",
	"./left-top-row-3.webp": "d86c",
	"./left-top-row-4.webp": "7d8a",
	"./left-top-row-5.webp": "68fb",
	"./right-bottom-row-1.webp": "6247",
	"./right-bottom-row-2.webp": "3afb",
	"./right-bottom-row-3.webp": "da8b",
	"./right-bottom-row-4.webp": "4830",
	"./right-bottom-row-5.webp": "799e",
	"./right-bottom-row-6.webp": "1ff7",
	"./right-home-row-1.webp": "67e8",
	"./right-home-row-2.webp": "70f4",
	"./right-home-row-3.webp": "bf06",
	"./right-home-row-4.webp": "e3f7",
	"./right-home-row-5.webp": "6394",
	"./right-home-row-6.webp": "c580",
	"./right-home-row-7.webp": "44d7",
	"./right-num-row-0.webp": "d169",
	"./right-num-row-1.webp": "feb4",
	"./right-num-row-2.webp": "21e1",
	"./right-num-row-3.webp": "e44d",
	"./right-num-row-4.webp": "4f73",
	"./right-num-row-5.webp": "ca29",
	"./right-num-row-6.webp": "1901",
	"./right-num-row-7.webp": "0289",
	"./right-resting-hand.webp": "ff21",
	"./right-top-row-1.webp": "3c15",
	"./right-top-row-2.webp": "cfd5",
	"./right-top-row-3.webp": "1575",
	"./right-top-row-4.webp": "b9ed",
	"./right-top-row-5.webp": "3180",
	"./right-top-row-6.webp": "6c12",
	"./right-top-row-7.webp": "8cab",
	"./right-top-row-8.webp": "bfc6",
	"./space.webp": "d85e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6679";